"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrailerPreviewTypeEnabled = exports.isPreviewEnabled = exports.getPreviewType = exports.hasTrailer = void 0;
var preview_types_1 = require("@wix/wix-vod-constants/dist/common/preview-types");
var hasTrailer = function (videoItem) {
    return Boolean(videoItem.trailerFileName);
};
exports.hasTrailer = hasTrailer;
var getPreviewType = function (videoItem) {
    return videoItem.previewType || preview_types_1.PREVIEW_TYPES.FIRST_20_SEC;
};
exports.getPreviewType = getPreviewType;
var isPreviewEnabled = function (videoItem) {
    return videoItem.previewType !== preview_types_1.PREVIEW_TYPES.NONE;
};
exports.isPreviewEnabled = isPreviewEnabled;
var isTrailerPreviewTypeEnabled = function (videoItem) {
    return videoItem.previewType === preview_types_1.PREVIEW_TYPES.TRAILER;
};
exports.isTrailerPreviewTypeEnabled = isTrailerPreviewTypeEnabled;
//# sourceMappingURL=preview.js.map